import { useState } from "react";
import ActiveCampaign from "./pages/Activecampaign";
import useHttp from "../../../hooks/use-http";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { endPoints } from "../../../config/end-points";
import { settingAction } from "../../../store/setting-store";
import MailChimp from "./pages/Mailchimp";
import GetResponse from "./pages/GetResponse";
import ConvertKit from "./pages/ConvertKit";
import { SiMailchimp } from "react-icons/si";
import { TbMailCog, TbBrandCampaignmonitor, TbMailForward } from "react-icons/tb";
import { FiSend } from "react-icons/fi";

const providerTabs = [
  { id: "convertkit", label: "ConvertKit", icon: TbMailForward },
  { id: "mailchimp", label: "Mailchimp", icon: SiMailchimp },
  { id: "getresponse", label: "GetResponse", icon: TbMailCog },
  { id: "activecampaign", label: "ActiveCampaign", icon: TbBrandCampaignmonitor },
];

const Autoresponder = () => {
  const { sendRequest } = useHttp();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("convertkit");

  const is_autoresponder_loaded = useSelector(
    (state) => state.settings.is_autoresponder_loaded
  );

  useEffect(() => {
    if (!is_autoresponder_loaded) {
      sendRequest(
        {
          url: endPoints.fetchAllKeys,
          method: "GET",
        },
        (response) => {
          dispatch(
            settingAction.setAutoresponder({ autoresponder: response.body })
          );
          dispatch(settingAction.setAutoresponderStatus({ status: true }));
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [is_autoresponder_loaded]);

  const renderTabContent = () => {
    switch (activeTab) {
      case "convertkit":
        return (
          <>
            <h4 className="st-responder-title">Manage Your ConvertKit Account</h4>
            <ConvertKit />
          </>
        );
      case "mailchimp":
        return (
          <>
            <h4 className="st-responder-title">Manage Your Mailchimp Account</h4>
            <MailChimp />
          </>
        );
      case "getresponse":
        return (
          <>
            <h4 className="st-responder-title">Manage Your GetResponse Account</h4>
            <GetResponse />
          </>
        );
      case "activecampaign":
        return (
          <>
            <h4 className="st-responder-title">Manage Your ActiveCampaign Account</h4>
            <ActiveCampaign />
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className="st-form-card">
      <div className="st-card-head">
        <div className="st-card-head-icon st-icon-auto">
          <FiSend size={19} />
        </div>
        <div>
          <h3 className="st-card-head-title">AutoResponder</h3>
          <p className="st-card-head-desc">Connect your email service for automated lead management</p>
        </div>
      </div>

      <div className="st-card-body">
        {/* Provider Tabs — Modern Segmented Style */}
        <div className="st-responder-nav">
          <div className="st-tabs">
            {providerTabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  type="button"
                  className={`st-tab-btn${activeTab === tab.id ? " st-tab-active" : ""}`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  <span className="st-tab-icon">
                    <Icon size={14} />
                  </span>
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>

        {/* Tab Content — Centered & Animated */}
        <div className="st-tab-content-wrapper">
          <div className="st-tab-content" key={activeTab}>
            {renderTabContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Autoresponder;
